const NotFound = (props) => {
  return(<div>404 Page not NotFound</div>)
}

export default NotFound